
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import { FieldList } from '../';
import * as Api from 'api';

const copy = obj => (JSON.parse(JSON.stringify(obj)));

class ClientModify extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      client: copy(this.props.client),
      dirty : false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);

  }
  componentWillUpdate(nextProps, nextState) {
    if(!this.props.client || nextProps.client._id != this.props.client._id || nextProps.client.last_updated != this.props.client.last_updated) {
      this.setState({ client: copy(nextProps.client) });
    }
  }
  componentDidMount() {
    Api
      .fetchFieldGroupOrder('Client')
      .then(order => this.setState({ order }));
  }
  handleChange(value, name) {
    let copy_state = copy(this.state.client);
    let entity = copy_state;
    let names = name.split('.'); //address.street
    //names = ['address','street']

    while(names.length > 1) {
      let name = names.shift(); //name = address, names = ['street']
      if(!entity[name]) { //entity[name] = true
        entity[name] = {}; //
      }
      entity = entity[name];
    }

    entity[names.shift()] = value;
    this.setState({client : copy_state, dirty : true});
  }
  handleSave() {
    const { client } = this.state;
    this.props.onSave();
    this.props.toggleFetchingClient(true);
    this.props.sendSocketEmit({
      client,
    }, 'client-update')
  }
  render() {
   return (
        <div className='clearfix'>
          <div className="mb-sm">
            <FieldList
              groupOrder={this.state.order}
              entity={this.state.client}
              fields={[...(this.props.fields || [])]}
              onChange={this.handleChange}
            />
          </div>
          <div onClick={this.handleSave} className="btn btn-success pull-right"><i className="fa fa-save"></i> Save</div>
        </div>
      );
  }
}

ClientModify.propTypes = {

}

const mapStateToProps = ({ client, fields }) => ({ client, fields: fields.Client });

export default connect(mapStateToProps, Actions)(ClientModify);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-modify.js